import httpService from './http.service';
const shareConfigurationInfo = async (email, sessionId) => {
  let shareModel = {
    to: email,
    sessionId: sessionId
  };

  try {
    let response = await httpService.postByObject(`share`, shareModel);
  } catch (error) {
    console.log(error);
  }
};

export default shareConfigurationInfo;
